// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","selected":"Button_selected__NZP20","unselected":"Button_unselected__eARIW","big":"Button_big__aHkHM"};